// Shared special-user privilege configuration.
//
// IMPORTANT: These lists are intentionally NOT merged. Each screen exposes a
// specific subset of special users for feature visibility (originally inline
// `EmpId == ...` checks). Do not widen a list without explicit approval from
// the team lead.

// Full special-user set shown in the main navigation (Header).
// Adds 4772 (sikandar) and 4306 (faiz) on top of the base set.
export const HEADER_SPECIAL_USERS = [4517, 4772, 4306, 3073, 1642, 4214];

// Base special-user set used by most screens: SoftwareTickets,
// SupportTickets, ProSoftwareTeam, ProjectStatus, Checklist and Attendance.
export const SPECIAL_USERS = [4517, 3073, 1642, 4214];

// ChangeRequestFrom special set.
export const CHANGE_REQUEST_SPECIAL_USERS = [4517, 3073, 1642, 4214];

// Roles that can see the Settings entry in the Header.
export const SETTINGS_ROLES = [1, 4, 7, 11, 12, 13];

// The "President" EmpId — sees the BMR menu only; the Client, Software,
// Support and Settings entries in the Header are hidden for this user
// regardless of role.
export const PRESIDENT_USERS = [5761, 904, 6490, 5769];

// COO (javaid.iqbal@bellmedex.com)
export const COO_USERS = [5239];

// EmpIds allowed to create new ProSoftware / Scrum software tickets.
export const SOFTWARE_TICKET_CREATE_USERS = [1642, 4517, 3073, 5259];

// Loose id matching that mirrors the `==` comparisons previously scattered
// across the app, so string or numeric ids both match.
export const includesId = (list, id) =>
  list.some((allowed) => Number(allowed) === Number(id));

// True when the given EmpId is in the provided special-user list.
export const isSpecialUser = (empId, list = SPECIAL_USERS) =>
  includesId(list, empId);

// True when the given EmpId belongs to the "President" list above.
export const isPresident = (empId) => includesId(PRESIDENT_USERS, empId);

// True when the given EmpId belongs to the "COO" list above.
export const isCOO = (empId) => includesId(COO_USERS, empId);

// True when the given EmpId can create new ProSoftware / Scrum tickets.
export const canCreateSoftwareTicket = (empId) =>
  includesId(SOFTWARE_TICKET_CREATE_USERS, empId);
